<template>
  <div class="text-center">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <ButtonDefault
          :button-name="$t('shooting.buttons.player.player')"
          :outlined="true"
          @click="openDropdownButton(attrs)"
          v-bind="attrs"
          v-on="on"
        />
      </template>
      <v-list v-if="!loadUrl" width="250px">
        <v-list-item @click="goToPlayer">
          <v-list-item-title>{{ $t('shooting.buttons.player.show') }}</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="accessEmailOptions" class="justify-center" @click.stop="openSendEmailDialog">
          <v-list-item-title>{{ $t('shooting.buttons.player.sendByEmail') }}</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="accessSmsOptions" class="justify-center" @click.stop="openSendSMSDialog">
          <v-list-item-title v-if="!loadUrl">{{ $t('shooting.buttons.player.sendBySms') }}</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-list v-else>
        <v-list-item>
          <v-progress-circular :width="3" color="primary" indeterminate></v-progress-circular>
        </v-list-item>
      </v-list>
    </v-menu>

    <SendEmailDialog
      v-model="showScheduleForm"
      from="Player"
      :shootingType="shootingType"
      :username="username"
      :userEmail="userEmail"
      :initialObjectValue="objectValue"
      :initialText="initialText"
      :marketplaceProductRef="reference"
    >
    </SendEmailDialog>
    <SendMessageByPhone
      v-model="showScheduleSMSForm"
      from="Player"
      :shootingType="shootingType"
      :username="username"
      :userEmail="userEmail"
      :initialText="initialText"
      :marketplaceProductRef="reference"
    >
    </SendMessageByPhone>
  </div>
</template>

<script>
import SendEmailDialog from '@/components/SendEmailDialog.vue'
import SendMessageByPhone from '@/components/SendMessageByPhone.vue'
import { mapGetters } from 'vuex'
import ButtonDefault from '@/components/common/atoms/ButtonDefault.vue'

export default {
  name: 'PlayerButtonDropdown',

  components: {
    SendMessageByPhone,
    SendEmailDialog,
    ButtonDefault
  },

  props: {
    shootingId: String,
    registration: {
      type: String,
      default: ''
    },
    shootingType: {
      type: String
    }
  },

  data() {
    return {
      showScheduleForm: false,
      showScheduleSMSForm: false,
      loadUrl: false,
      objectValue: '',
      initialText: '',
      url: null,
      reference: null
    }
  },

  computed: {
    ...mapGetters(['username', 'userEmail', 'hasSpecificAccess']),
    accessEmailOptions() {
      return this.hasSpecificAccess('useStampothequeEmail')
    },
    accessSmsOptions() {
      return this.hasSpecificAccess('useStampothequeSMS')
    }
  },

  methods: {
    async openDropdownButton(e) {
      //Special event from attrs of button
      const open = e['aria-expanded']

      if (open === 'false') {
        await this.getPlayerInformations()
      }
    },
    openSendEmailDialog() {
      if (!this.url) return
      this.initTextEmail()
      this.showScheduleForm = true
    },
    openSendSMSDialog() {
      if (!this.url) return
      this.initTextSMS()
      this.showScheduleSMSForm = true
    },
    async getPlayerInformations() {
      this.loadUrl = true
      const { ref, url } = await this.$store.dispatch('getPlayerInformations', this.shootingId)
      this.reference = ref
      this.url = url
      this.loadUrl = false
    },
    initTextEmail() {
      let space = '\n\n'
      let objetText = this.$t('sendPlayerByMail.objectText')
      let bodyMessage_1 = this.$t('sendPlayerByMail.bodyMessage_1') + space
      let bodyMessage_2 = this.$t('sendPlayerByMail.bodyMessage_2') + space
      let url = this.url + space

      this.objectValue = objetText + ' ' + this.registration
      this.initialText = bodyMessage_1 + url + bodyMessage_2
    },
    initTextSMS() {
      let space = '\n\n'
      let bodyMessage_1 = this.$t('sendPlayerBySMS.bodyMessage') + space
      let thanksMessage = this.$t('sendPlayerBySMS.thanksMessage')
      let url = this.url + space

      this.initialText = bodyMessage_1 + url + thanksMessage
    },
    async goToPlayer() {
      if (this.reference) {
        this.$mam.shootingsDisplayPlayer()
        this.$router.push({
          path: `/public/player/${this.reference}`
        })
      }
    }
  }
}
</script>
